import ReactJsonView from '@microlink/react-json-view'
import { BallTriangle } from 'react-loading-icons'

type FinchApiOutputProps = {
  isLoading: boolean;
  data: any;
  error: string;
}

function FinchApiOutput ({ isLoading, data, error }: FinchApiOutputProps) {
  if (isLoading) {
    return (
      <div className='border mt-4 p-4 bg-white rounded-md w-full flex justify-center'>
        <BallTriangle
          stroke='#4f46e5'
          style={{ width: '40px', height: '100px' }}
        />
      </div>
    )
  }

  if (error) {
    return (
      <div className='border mt-4 p-4 bg-white rounded-md w-full flex justify-center'>
        <div className='text-red-500'>Error: {error}</div>
      </div>
    )
  }

  if (!data) {
    return (
      <div data-testid='no-data' className='border mt-4 p-4 bg-white rounded-md w-full flex justify-center italic'>
        No data fetched - Please select an endpoint and click "Fetch" to get
        data.
      </div>
    )
  }

  return (
    <div data-testid='json-output' className='border mt-4 p-4 bg-white rounded-md'>
      <ReactJsonView src={data} />
    </div>
  )
}

export default FinchApiOutput
